import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchDestinations } from '../../../actions/destinations';
import { getCyoaID, getCyoaName } from '../../../helpers/cyoaHelper';


class NextDestinationPanel extends PureComponent {

  constructor(props){
    super(props);
    this.onNextDestination = this.onNextDestination.bind(this);
  }

  onNextDestination(){
    const {
      FetchDestinations,
      currency:{iso_currency_code},
      builderlist:{activeCity, data}
    } = this.props;

    //populate current list of city id's or tour id
    let wizardlist = [];

    for(let i = 1; i < data.length; i++){
      if(data[i].type === 'sector' && data[i].reservations !== null){
        wizardlist.push(data[i].reservations.end_city_id);
      }else{
        wizardlist.push(data[i].tour_id);
      }
    }

    FetchDestinations(iso_currency_code, activeCity, null, null, wizardlist.toString(), getCyoaID());
  }

  render(){
    return (
      <div className="next-destination-panel simple-builder" onClick={this.onNextDestination}>
        <div className="row">
          <div className="column small-12">
            <p className={`no-margin ${getCyoaName()}`}>
              <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <circle fill="#F60" cx="7.5" cy="7.5" r="7.5"/>
                  <path d="M11.8 7.1h-4V3.2s0-.2-.2-.2h-.2c-.2 0-.3.1-.3.2v4H3.2s-.2 0-.2.2v.2c0 .2.1.3.2.3h4v3.9s0 .2.2.2h.2c.2 0 .3-.1.3-.2v-4h3.9s.2 0 .2-.2v-.2c0-.2-.1-.3-.2-.3z" fill="#FFF" fillRule="nonzero"/>
                </g>
              </svg>
              Add next destination
            </p>
          </div>
        </div>
      </div>
    )
  }

}

function mapStateToProps(state){
  return {
    currency:state.currency,
    builderlist:state.builderlist
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchDestinations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NextDestinationPanel);



// WEBPACK FOOTER //
// ./src/components/builder/components/next-destination-panel.js